import { motion } from "framer-motion";

export const ease = [0.16, 1, 0.3, 1];
const VIEW = { once: true, amount: 0.15 };

export const goTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={VIEW}
    transition={{ duration: 1.4, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "112%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.5, ease, delay: i * 0.13 } }),
};

export const MaskLines = ({ lines, className = "", lineClass = () => "", onLoad = false, delay = 0 }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(onLoad ? { animate: "show" } : { whileInView: "show", viewport: VIEW })}
    transition={{ delayChildren: delay }}
  >
    {lines.map((l, i) => (
      <span key={`${l}-${i}`} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span className={`block ${lineClass(i)}`} variants={lineVariants} custom={i + delay / 0.13}>
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, light = false, testId }) => (
  <p data-testid={testId} className={`flex items-center gap-3 text-[12px] uppercase tracking-[0.28em] font-medium ${light ? "text-[#7FD9D6]" : "text-[var(--brass-ink)]"}`}>
    <span className={`h-px w-8 ${light ? "bg-[#7FD9D6]" : "bg-[var(--brass)]"}`} />
    {children}
  </p>
);
